import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { OwnerSummaryCardContent } from 'src/v2/views/owner-reveal/insights/owner-summary/owner-summary/content'

export const OwnerSummaryOverview: FC = () => {
  return (
    <WidgetCard
      id="owner-summary"
      title="Owner Summary"
      headerBgColor={Colors.primaryRed700}
      headerTextColor={Colors.textWhite}
      sections={[
        {
          content: <OwnerSummaryCardContent />,
        },
      ]}
    />
  )
}
